import React, { useEffect, useState } from 'react';
import { Input, InputWrapper, LabelText, Text } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Select from 'react-select'
import { COUNTRY_PHONE_CODE, EMAIL } from "../../appconstants";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';

type Props = {
  control: any,
  errors: any,
  readOnly: Array,
  validation: boolean,
  requiredPhone: boolean,
  validateInvoice: boolean,
  payment: Object,
}

const Customer = (props: Props) => {
  const { control, errors, readOnly, requiredPhone, validateInvoice, payment } = props;
  const [validation, setValidation] = useState(true);
  const [inputPhoneReadOnly, setInputPhoneReadOnly] = useState(false);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  useEffect(() => {
    setValidation(props.validation)
  }, [props.validation]);

  useEffect(() => {
    setInputPhoneReadOnly(readOnly && readOnly.includes("phone"))
  }, [props.readOnly]);

  const isNameValidate = (data: string) => {
    const custometName = data && data.trim();
    const count = custometName.length;
    if (count < 5) {
      return "The name should be minimum 5 characters";
    }
  };

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (data) {
      if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
        return 'The phone number is invalid';
      }
    }
  };

  const customStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important'
    }),
  };

  const disableStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  return (
    <>
      {
        payment && payment.account && payment.account.gid === 'account-25729ddf59914c9abcb41a107d824330' ? (
          <LabelText>
            Name / Organization Name
          </LabelText>
        ) : (
          <LabelText>
            Name
          </LabelText>
        )
      }
      <Controller
        defaultValue={""}
        color={errors.cname ? "red" : "inherit"}
        marginBottom="0px"
        control={control}
        name="cname"
        placeholder="Enter your name"
        rules={validation && {
          required: 'Name is required',
          validate: isNameValidate,
        }}
        as={<Input
          readOnly={readOnly && readOnly.includes("name")}
          style={{
            background: (readOnly && readOnly.includes("name")) ? BACKGROUND_COLOR : '',
            color: (readOnly && readOnly.includes("name")) ? COLOR : ''
          }}
        />}
      />
      <ErrorMessage
        errors={errors}
        name="cname"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <LabelText>
        E-Mail
      </LabelText>
      <Controller
        marginBottom="0px"
        defaultValue={""}
        color={errors.email ? "red" : "inherit"}
        control={control}
        name="email"
        placeholder="Enter your email address"
        rules={validation && {
          required: 'Email is required',
          pattern: {
            value: EMAIL.NEW_EMAIL_REGEX1,
            message: EMAIL.DEFAULT_ERROR_MESSAGE,
          },
        }}
        as={<Input
          type="email"
          readOnly={readOnly && readOnly.includes("email")}
          style={{
            background: (readOnly && readOnly.includes("email")) ? BACKGROUND_COLOR : '',
            color: (readOnly && readOnly.includes("email")) ? COLOR : ''
          }}
        />}
      />
      <ErrorMessage
        errors={errors}
        name="email"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <LabelText>
        Phone {validateInvoice ? "(Optional)" : null}
      </LabelText>
      <InputWrapper
        className="row"
        display="flex"
        marginTop="8px"
        borderRadius="4px"
        width="299px"
      >
        <Controller
          defaultValue={""}
          color={errors.countryCallingCode ? "red" : "inherit"}
          marginBottom="0px"
          control={control}
          name="countryCallingCode"
          placeholder="select"
          rules={validation && requiredPhone && {
            required: 'Calling Code is required'
          }}
          as={<Select
            className="col-4 px-0 border-0"
            isSearchable={!inputPhoneReadOnly}
            menuIsOpen={inputPhoneReadOnly ? false : undefined}
            theme={theme => ({
              ...theme,
              borderRadius: "4px 0 0 4px",
              boxShadow: 0,
            })}
            getOptionLabel={(option) => option.value}
            styles={inputPhoneReadOnly ? disableStyles : customStyles}
            options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
        />
        {
          (validation && requiredPhone) ? (
            <Controller
              className="col"
              defaultValue={""}
              color={errors.phone ? "red" : "inherit"}
              border="0px !important"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              paddingRight="0"
              control={control}
              name="phone"
              rules={validation && requiredPhone && {
                required: 'Phone number is required',
                validate: isPhoneNumberValidate
              }}
              as={<NumberFormat
                type="tel"
                allowNegative={false}
                decimalScale={0}
                readOnly={inputPhoneReadOnly}
                borderRadius="none"
                style={{
                  background: (inputPhoneReadOnly) ? BACKGROUND_COLOR : '',
                  color: (inputPhoneReadOnly) ? COLOR : ''
                }}
              />}
              placeholder="Enter your phone number"
              customInput={Input}
            />
          ) : (
            <Controller
              className="col"
              defaultValue={""}
              color={errors.phone ? "red" : "inherit"}
              border="0px !important"
              marginBottom="0px"
              marginTop="0px"
              marginLeft="0px"
              paddingRight="0"
              control={control}
              name="phone"
              rules={{
                validate: isPhoneNumberValidate,
              }}
              as={<NumberFormat
                type="tel"
                allowNegative={false}
                decimalScale={0}
                readOnly={inputPhoneReadOnly}
                borderRadius="none"
                style={{
                  background: (inputPhoneReadOnly) ? BACKGROUND_COLOR : '',
                  color: (inputPhoneReadOnly) ? COLOR : ''
                }}
              />}
              placeholder="Enter your phone number"
              customInput={Input}
            />
          )
        }

      </InputWrapper>
      <ErrorMessage
        errors={errors}
        name="phone"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <ErrorMessage
        errors={errors}
        name="countryCallingCode"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
    </>
  );
};

export default Customer;
